export const detectKoli = (sizes, koliTypes) => {
  for (const t of koliTypes) {
    const entries = Object.entries(t.ratios).filter(([, r]) => r > 0);
    if (!entries.length) continue;
    const n = (sizes[entries[0][0]] || 0) / entries[0][1];
    const keys = Object.keys(sizes).filter((k) => sizes[k] > 0);
    if (n > 0 && Number.isInteger(n) && keys.every((k) => t.ratios[k]) && entries.every(([sz, r]) => (sizes[sz] || 0) === r * n))
      return { koli_type_id: t.id, koli_count: String(n) };
  }
  return { koli_type_id: "", koli_count: "" };
};

// Groups order items into { product_id: { size: qty } }
export const groupByProduct = (items, qtyOf = (it) => it.qty) => {
  const by = {};
  items.forEach((it) => {
    const q = qtyOf(it);
    if (q <= 0) return;
    by[it.product_id] = by[it.product_id] || {};
    by[it.product_id][it.size] = (by[it.product_id][it.size] || 0) + q;
  });
  return by;
};
